import { render, staticRenderFns } from "./emailContent.vue?vue&type=template&id=47aa5631&"
import script from "./emailContent.vue?vue&type=script&lang=js&"
export * from "./emailContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports